import { Navigate } from "react-router-dom";
import Auth from "../utils/auth";
import { hasRole, hasAnyRole } from '../utils/permissions';

const Protected = ({ children, permCheck }) => {
  const isLoggedIn = Auth.loggedIn()
  const perm = Auth.getPermissions()

  if (perm === false){
    return <Navigate to="/login-portal" replace />;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login-portal" replace />;
  }

  if (permCheck) {
    // Support both single role string and array of roles
    const allowed = Array.isArray(permCheck)
      ? hasAnyRole(perm, permCheck)
      : hasRole(perm, permCheck);
    if (!allowed) {
      return <Navigate to="/bdr-office/tasks" replace />;
    }
  }

  return children;
};

export default Protected;
